import FilledButton from "../../FilledButton";
import BtnLoader from "../../../layout/BtnLoader";

const UpdatePop = ({ setUpdatePop, updateCourse, updateLoad, subTitle="Do you want to proceed?",  tittle="Course Update", desc="A new course update is available. By selecting to update the course\n" +
"                you will overwrite any previous progress history.", }) => {
    return (
        <div className="pop_content delete_model">
            <h2 className="delete_group_modal">{tittle}</h2>
            <p className="mb-40 delete_group_modal">{desc}</p>
            <h6 className="mb-40 delete_group_modal">{subTitle}</h6>
            <div className="text-center mb-4">
                <FilledButton className="cursor_pointer btn_reject signin_online btn btn_coures_availabe" onClick={() => setUpdatePop(false)} value="CANCEL" />
                {
                    updateLoad ? (
                        <button className="cursor_pointer btn_primary prof btn btn_primary_delete"><BtnLoader/></button>
                    ) : (
                        <FilledButton className="cursor_pointer btn_primary prof btn btn_primary_delete" onClick={() => updateCourse()} value="Yes" />
                    )
                }
            </div>
        </div>
    )
};

export default UpdatePop